<template>
  <div class="admin-request-list">
    <div class="main-layout__head main-layout__head_pb24">
      <h2 class="main-title">{{ $t("navigation.requests") }}</h2>
    </div>

    <div ref="hidden_helper"></div>

    <!-- <div class="userlist userlist_vh76"> -->
    <!-- <div class="userlist__items">
        <div class="userlist__item-wrapper">
          <div class="userlist__item userlist__item_head hover_green">
            <div class="userlist__block-text">#</div>
            <div class="userlist__item-contact row-w15">
              {{ $t("listsHeader.contacts") }}
            </div>
            <div class="userlist__item-name row-w20">
              {{ $t("listsHeader.description") }}
            </div>
            <div class="userlist__item-status row-w10">
              {{ $t("listsHeader.status") }}
            </div>
            <div class="userlist__item-status row-w10">
              {{ $t("listsHeader.date") }}
            </div>
            <div class="userlist__item-time row-w6">
              {{ $t("listsHeader.time") }}
            </div>
            <div class="userlist__item-actions">
              {{ $t("listsHeader.actions") }}
            </div>
          </div>
        </div>
    </div>-->

    <!-- <div class="userlist__wrapper" v-bar>
    <div class="userlist__block" @scroll="scroll">-->
    <div class="main-layout__box">
      <div class="main-layout__item main-layout__item_head main-layout__item_hover">
        <div class="w-3 t-c foz-23">#</div>
        <div class="userlist__item-contact row-w15">{{ $t("listsHeader.contacts") }}</div>
        <div class="row-w20">{{ $t("listsHeader.description") }}</div>
        <div class="userlist__item-status row-w10">{{ $t("listsHeader.status") }}</div>
        <div class="userlist__item-status row-w10">{{ $t("listsHeader.date") }}</div>
        <div class="userlist__item-time row-w6">{{ $t("listsHeader.time") }}</div>
        <div class="userlist__item-actions">{{ $t("listsHeader.actions") }}</div>
      </div>

      <transition-group
        name="list"
        tag="div"
        class="main-layout__list main-layout__list_mxh75"
        @scroll="scroll"
      >
        <div
          v-for="(request, index) in requests"
          :key="index"
          class="main-layout__item main-layout__item_hover"
          :class="{
            delete: request.deletion_tag,
          }"
        >
          <div class="w-3 t-c">{{ index + 1 }}</div>
          <div class="userlist__item-contact row-w15" :title="request.name">{{ request.name }}</div>
          <div class="row-w20" :title="request.description">{{ request.description }}</div>
          <div class="userlist__item-status row-w10" :title="request.status">{{ request.status }}</div>
          <div
            class="userlist__item-status row-w10"
            :title="request.date"
          >{{ checkIsUndefined(request.date) }}</div>
          <div class="userlist__item-time row-w6" :title="request.time">{{ request.time }}</div>
          <div class="userlist__item-actions" v-if="$guard('write', 'Requests')">
            <div @click="addApplication(request)">
              <svg class="main-layout__item-icon">
                <use xlink:href="/images/svg/symbols.svg#svg-add-work" />
              </svg>
            </div>
            <div>
              <div @click="openDeleteModal(request)">
                <svg width="28px" height="28px" class="main-layout__item-icon">
                  <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
                </svg>
              </div>
            </div>
            <div class="userlist__item-button">
              <delete-request
                v-if="$guard('delete', 'Requests') && request.deletion_tag"
                :item="request"
                :type="'landing/requests'"
                @save="getRequests"
                @remove="openDeleteModalAdapter"
              />
            </div>
          </div>
        </div>
      </transition-group>
      <div class="userlist__item" v-if="!requests">{{ $t("lists.listEmpty") }}</div>
    </div>
    <!-- </div>
    </div>-->
    <!-- </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import deleteRequest from '@/components/controls/deleteRequest'

import { notificationStore } from '@/utils/notificationStore'
import { signalingManager } from '@/utils/audioHandler'

export default {
    name: 'admin-requests-list',
    components: {
        deleteRequest,
    },
    data() {
        return {
            page: 1,
        }
    },
    computed: {
        ...mapGetters({
            requests: 'getAdminRequests',
            notification: 'requests/notification',
            notificationShow: 'requests/notificationShow',
        }),
    },
    watch: {
        notificationShow(v) {
            if (v) {
                this.showRequest(this.notification.id)
            }
        },
    },
    methods: {
        ...mapMutations({
            setContact: 'requests/setContact',
            setDescription: 'requests/setDescription',
            setFormData: 'requests/setFormData',
            toggleShowModalAdd: 'requests/toggleShowModalAdd',
            setShowModalAdd: 'requests/setShowModalAdd',
            toggleShowModalDelete: 'requests/toggleShowModalDelete',
            setDeleteId: 'requests/setDeleteId',
            clearAdminRequests: 'clearAdminRequests',
            setIsLastPage: 'setIsLastPage',
            setDeletionStatus: 'requests/setVDeletionStatus',
            clearLandingRequests: 'clearLandingRequests',
        }),
        ...mapActions({
            getAdminRequests: 'getAdminRequests',
        }),
        async scroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
            if (Math.round(clientHeight + scrollTop) >= scrollHeight) {
                const page = ++this.page

                await this.getAdminRequests({ page })
            }
        },
        checkIsUndefined(value) {
            return value === 'undefined NaN, NaN' ? '-' : value
        },
        getDate(v, { hour, minute }) {
            const localDate = v === null ? moment().add(1, 'd') : moment(v, 'DD/MM/YYYY')

            return moment(moment(localDate).format('YYYY-MM-DDT22:00:00.000[Z]'))
                .set({
                    hour, minute, second: 0, millisecond: 0,
                })
                .subtract(1, 'd')
                .toISOString()
        },
        getEstimate(estimate) {
            if (estimate === null) {
                return ['60 Minuten', '']
            }

            return estimate.split('–')
        },
        getAddress(query) {
            const vm = this

            // eslint-disable-next-line no-undef
            const placeService = new google.maps.places.PlacesService(
                this.$refs.hidden_helper,
            )

            placeService.findPlaceFromQuery(
                {
                    query,
                    fields: ['place_id', 'geometry'],
                },
                (results, status) => {
                    // eslint-disable-next-line no-undef
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        placeService.getDetails(
                            {
                                placeId: results[0].place_id,
                                fields: ['address_components'],
                            },
                            (place) => {
                                const result = []
                                const fields = [
                                    'route',
                                    'street_number',
                                    'postal_code',
                                    'locality',
                                    'country',
                                ]

                                place.address_components.forEach((element) => {
                                    if (fields.lastIndexOf(element.types[0]) !== -1) {
                                        result.push(element)
                                    }
                                })

                                const data = {
                                    address: {
                                        index: result[4].long_name,
                                        country: result[3].long_name,
                                        city: result[2].short_name,
                                        route: result[1].short_name,
                                        short_name: result[0].short_name,
                                    },
                                    location: {
                                        lat: results[0].geometry.location.lat(),
                                        lng: results[0].geometry.location.lng(),
                                    },
                                }

                                vm.setAddress(data)
                                vm.setShowModalAdd(true)
                            },
                        )
                    }
                },
            )
        },
        getContact(req) {
            if (req === undefined) {
                return null
            }

            if (req.name === undefined) {
                req.name = ''
            }

            const fullName = req.name.split(' ')

            if (req.client) {
                return {
                    first_name: req.client.first_name,
                    last_name: req.client.last_name,
                    phone: req.phone,
                    email: req.email,
                    id: req.client.id,
                    request_id: req.id,
                    type: req.type,
                }
            } else {
                return {
                    first_name: fullName[0] || '',
                    last_name: fullName[1] || '',
                    phone: req.phone,
                    email: req.email,
                    id: req.client === null ? '' : req.client.id,
                    request_id: req.id,
                    type: req.type,
                }
            }
        },
        setAddress(data) {
            this.setFormData({
                key: 'address',
                value: {
                    house: data.address.short_name,
                    street: data.address.route,
                    postcode: data.address.index,
                    city: data.address.city,
                    country: data.address.country,
                    latitude: data.location.lat,
                    longitude: data.location.lng,
                },
            })
        },
        addApplication(req) {
            const contact = this.getContact(req)
            if (contact === null) return

            this.setContact(contact)

            const hours = req.time !== null ? parseInt(req.time.split(':')[0]) : 8
            const minute = req.time !== null ? parseInt(req.time.split(':')[1]) : 0
            const date = this.getDate(req.date, { hour: hours, minute })

            this.setFormData({ key: 'final_price', value: 0 })
            this.setFormData({ key: 'source', value: 'landing-page' })
            this.setFormData({ key: 'duration', value: '01:00' })
            this.setFormData({
                key: 'dateOptions',
                value: { text: date, value: null },
            })
            this.setFormData({ key: 'description', value: req.description })
            this.setFormData({ key: 'images', value: this.getImages(req.images) })

            if (notificationStore.has(req.id)) {
                if (signalingManager.isPlaying) {
                    signalingManager.stop()
                }

                const notification = notificationStore.get(req.id)
                notification.close()
                notificationStore.add(req.id, null)
            }

            if (req.address) {
                this.getAddress(req.address)
            } else {
                this.setShowModalAdd(true)
            }
        },
        getImages(images) {
            if (images === null) {
                return null
            }

            if (images[0] === '') {
                return null
            }

            return images
        },
        getRequests() {
            this.clearAdminRequests([])
            this.setIsLastPage(false)
            this.getAdminRequests({})
        },
        getRequestById({ id }) {
            if (this.requests.length === 0) {
                return
            }

            return this.requests.filter((request) => request.id === id)[0]
        },
        openDeleteModalAdapter(id) {
            this.openDeleteModal({ id })
        },
        openDeleteModal({ id, deletion_tag }) {
            this.setDeleteId(id)
            this.setDeletionStatus(
                deletion_tag && !this.$guard('delete', 'Requests'),
            )
            this.toggleShowModalDelete()
        },
        async showRequest(landing_request_id) {
            this.clearLandingRequests()
            await this.getAdminRequests({})

            const request = this.getRequestById({
                id: landing_request_id,
            })

            this.addApplication(request)
        },
        async preparePage() {
            if (this.$route.params && this.$route.params.landing_request_id) {
                this.showRequest(this.$route.params.landing_request_id)
            } else {
                await this.getAdminRequests({})
            }
        },
    },
    beforeMount() {
        this.clearLandingRequests()
        this.preparePage()
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/main";

.admin-request-list {
  height: calc(100vh - 160px) !important;
}

.requests__title {
  margin: 13px auto 13px;
  font-size: 32px;
  color: #4d4d4d;
}

// .userlist {
//   margin: 0 60px;
//   border-radius: 8px;
//   background-color: #ffffff;
//   width: calc(100% - 120px);
//   height: 75vh;
//   position: relative;
//   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);

//   &-head {
//     display: flex;
//     align-items: center;
//     font-size: 16px;
//     color: #4d4d4d;
//     padding: 10px 0;
//     padding-left: 64px;
//     font-family: "SFUIDisplay-Bold";

//     &__name {
//       width: 14.2%;
//     }

//     &__surname {
//       width: 14.2%;
//     }

//     &__phone {
//       width: 15%;
//     }

//     &__mail {
//       width: 14.5%;
//     }

//     &__desc {
//       width: 14.2%;
//     }

// &__status {
//   width: 14.3%;
// }
//   }

//   &__wrapper {
//     width: 100%;
//     height: 100%;
//     padding-bottom: 24px;
//     box-sizing: border-box;
//     overflow: scroll;
//   }

//   &__add {
//     position: absolute;
//     right: 25px;
//     bottom: -25px;
//     display: flex;
//     align-items: flex-end;

//     &-text {
//       color: #4d4d4d;
//       font-size: 12px;
//       margin-right: 16px;
//       font-family: $fontMedium;
//     }

//     &-button {
//       width: 56px;
//       height: 56px;
//       border-radius: 50%;
//       background-color: $primaryColor;
//       box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//       background-image: url("/images/icon/add.svg");
//       background-position: center;
//       background-size: 20px;
//       background-repeat: no-repeat;
//       transition: 0.5s;
//       cursor: pointer;

//       &:hover {
//         background-color: $secondColor;
//       }
//     }
//   }

//   &__block {
//     width: 100%;
//     display: flex;
//     position: relative;
//     height: 95% !important;

//     &-text {
//       position: absolute;
//       left: 0;
//       top: 0;
//       width: 64px;
//       height: 100%;
//       flex-shrink: 0;
//       font-family: $fontLight;
//       font-size: 30px;
//       color: #e0e0e0;
//       text-align: center;
//       text-transform: uppercase;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }
//   }

//   &__items {
//     width: 100%;
//     flex-grow: 1;
//     display: flex;
//     flex-direction: column;
//     overflow-x: auto;
//     // padding-bottom: 24px;
//   }

//   &__item {
//     position: relative;
//     display: flex;
//     align-items: center;
//     height: 50px;
//     width: 100%;
//     transition: 0.5s;
//     padding-left: 64px;
//     box-sizing: border-box;
//     font-size: 16px;
//     color: #4d4d4d;

//     &_head {
//       font-family: $fontBold;
//     }

//     &:hover {
//       background-color: rgba(#71bd4a, 0.15);

//       & .userlist__item-button {
//         opacity: 1;
//       }
//     }

//     &-img {
//       width: 36px;
//       height: 36px;
//       background-position: center;
//       background-size: cover;
//       border: 1px solid $secondColor;
//       border-radius: 50%;
//       margin-right: 16px;
//       margin-left: 5px;
//       flex-shrink: 0;
//     }

//     &-name {
//       width: 20%;
//       box-sizing: border-box;
//       padding-right: 16px;
//       padding-left: 1px;
//       padding-right: 1px;
//       white-space: nowrap;
//       overflow: hidden;
//       text-overflow: ellipsis;
//     }

// &-contact {
//   width: 15%;
// }

//     &-time {
//       width: 6%;
//     }

//     &-estimate {
//       width: 10%;
//     }

//     &-post {
//       font-size: 12px;
//       color: #4d4d4d;
//       flex-grow: 1;
//       width: 10%;
//       box-sizing: border-box;
//       padding-right: 16px;
//       padding-left: 1px;
//       padding-right: 1px;
//       white-space: nowrap;
//       overflow: hidden;
//       text-overflow: ellipsis;

//       &--show {
//         color: $primaryColor;
//         display: flex;
//         justify-content: flex-start;
//         align-items: center;
//         position: relative;
//         padding-right: 5px;

//         & span {
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           padding-right: 10px;
//         }

//         & img {
//           right: 0;
//           width: 13px;
//           transition: 0.5s;

//           &.show {
//             transform: rotate(180deg);
//           }
//         }
//       }
//     }

//     &-phone {
//       font-size: 16px;
//       color: #4d4d4d;
//       flex-grow: 1;
//       width: 8%;
//       box-sizing: border-box;
//       padding-right: 16px;
//       padding-left: 1px;
//       padding-right: 1px;
//       white-space: nowrap;
//       overflow: hidden;
//       text-overflow: ellipsis;
//     }

//     &-mail {
//       font-size: 16px;
//       color: #4d4d4d;
//       flex-grow: 1;
//       width: 10%;
//       box-sizing: border-box;
//       padding-right: 16px;
//       padding-left: 1px;
//       padding-right: 1px;
//       white-space: nowrap;
//       overflow: hidden;
//       text-overflow: ellipsis;
//     }

// &-status {
//   width: 10%;
//   text-align: left;
//   font-size: 16px;
//   color: #4d4d4d;
// }

//     &-buttons {
//       display: flex;
//       align-items: center;
//       width: 200px;
//     }

// &-actions {
//   display: flex;
// }

//     &-button {
//       margin-right: 16px;
//       transition: 0.5s;
//       cursor: pointer;

//       & .icon {
//         width: 30px;
//         height: 30px;
//         transition: 0.5s;

//         &:hover {
//           transform: scale(1.2);
//         }
//       }
//     }

//     &-wrapper {
//       position: relative;
//       display: flex;
//       flex-direction: column;
//       width: 100%;
//       cursor: pointer;
//     }

//     &--sub {
//       margin-left: calc(36px + 16%);

//       & .userlist__item-name {
//         width: 5%;
//       }

//       & .userlist__item-mail {
//         width: 5%;
//       }

//       & .userlist__item-phone {
//         width: 5%;
//       }

//       & .userlist__item-post {
//         width: 5%;
//       }

//       & .userlist__item-buttons {
//         flex-grow: 3;
//       }
//     }
//   }

//   &__subitems {
//     transform: scaleY(0);
//     transform-origin: top center;
//     opacity: 0;
//     position: absolute;
//     border-bottom: 1px solid $primaryColor;

//     & .userlist__item-post {
//       width: initial;
//       margin-top: 17.5px;
//       margin-bottom: 17.5px;
//     }
//   }
// }
</style>
